/**
 * InventoryPage.jsx — Router de inventario por tipo de negocio.
 *
 * botica          →  InventoryBotica  (lotes FEFO, semáforo vencimientos)
 * tienda_general  →  InventoryTienda  (movimientos simples + historial)
 *
 * La base de datos y la API son compartidas en ambos casos.
 */
import React from 'react';
import { isBotica } from '../hooks/useSucursal';
import InventoryBotica from './InventoryBotica';
import InventoryTienda from './InventoryTienda';

const InventoryPage = () => {
    if (isBotica()) {
        return <InventoryBotica />;
    }
    return <InventoryTienda />;
};

export default InventoryPage;